// API client for the Club Development Plan.
// Mirrors the getApiBase logic used elsewhere (src/utils/api.js, src/hooks/useAuth.js):
// production talks to itself, every other host (incl. Pages previews) talks to
// the production worker route, because the *.workers.dev subdomain is disabled.
function getApiBase() {
  let apiBase = import.meta.env.VITE_API_URL;
  if (!apiBase) {
    const host = window.location.hostname;
    if (host === 'strategy.eastgrinsteadac.co.uk') {
      apiBase = 'https://strategy.eastgrinsteadac.co.uk';
    } else {
      apiBase = 'https://strategy.eastgrinsteadac.co.uk';
    }
  }
  return apiBase;
}

/**
 * Load the club development plan.
 * @param {string} token - Bearer auth token
 * @returns {Promise<{ exists: boolean, plan: object, updatedAt?: string }>}
 */
export async function getPlan(token) {
  const API_BASE = getApiBase();
  try {
    const response = await fetch(`${API_BASE}/api/club-dev-plan`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.error || `Failed to load plan (${response.status})`);
    }

    return response.json();
  } catch (err) {
    if (err instanceof TypeError) {
      throw new Error('Network error while loading plan.');
    }
    console.error('getPlan error:', err);
    throw err;
  }
}

/**
 * Save the full club development plan.
 * @param {string} token - Bearer auth token
 * @param {object} planData - the complete plan state
 *   { clubInfo, strategic, situation, swot, themes }
 * @returns {Promise<{ success: boolean, savedAt: string }>}
 */
export async function savePlan(token, planData) {
  const API_BASE = getApiBase();
  try {
    const response = await fetch(`${API_BASE}/api/club-dev-plan`, {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ plan: planData }),
    });

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.error || `Failed to save plan (${response.status})`);
    }

    return response.json();
  } catch (err) {
    if (err instanceof TypeError) {
      throw new Error('Network error while saving plan.');
    }
    console.error('savePlan error:', err);
    throw err;
  }
}
